import { Link } from 'react-router';
import { Club } from '@repo/types';

export type ContactsProps = {
  club: Club;
};
export function Contacts({ club }: ContactsProps) {
  return (
    <div className="team-overview-general-info__wrapper">
      <h3 className="team-overview__tab-title">Contacts</h3>
      {club.staffMembers && (
        <ul className="team-overview-contacts__list">
          {club.staffMembers.map((member) => (
            <li className="team-overview-contacts__list-item">
              <span className="team-overview-contacts__member-job">{member.job}</span>
              <span className="team-overview-contacts__member-name">{member.name}</span>
              {member.email && <Link to={`mailto:${member.email}`}>{member.email}</Link>}
              {member.phone && <Link to={`tel:${member.phone}`}>{member.phone}</Link>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
